var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isFilterChoiceQueryValue, } from 'src/redux/cases/types/filtersTypes';
// This breaks tests because of an issue with 'canvas' import in PDFJS (transitive from 'viewsHelpers')
// Maybe we should split the 'viewsHelpers' to extract a 'pdfHelpers' in order to isolate this issue...
//
// import {
//   isOptionSelected,
//   SelectValueType,
// } from 'src/ui/components/Input/Select/Select'
import { isOptionSelected } from 'src/ui/components/Input/Select/selectHelpers';
export var buildSelectListOptions = function (filter) {
    var options = buildSelectListOptionsFromChoices(filter.choices);
    if (options && options.length > 0 && typeof options[0] === 'string') {
        return {
            fieldNames: filter.fieldNames,
            options: options,
        };
    }
    return { options: options };
};
var buildSelectListOptionsFromChoices = function (choices) {
    return choices.map(function (choice) {
        var fieldNames = choice.fieldNames, label = choice.label, value = choice.value;
        if (Array.isArray(value)) {
            return {
                fieldNames: fieldNames,
                label: label,
                options: buildSelectListOptionsFromChoices(value),
            };
        }
        return label;
    });
};
export var buildQueryValuesByFieldName = function (filter, selectedQueries) {
    var id = filter.id, fieldNames = filter.fieldNames, choices = filter.choices;
    var queryConf = selectedQueries.find(function (queryConf) { return queryConf.id === id; });
    var outputMap = {};
    fillQueryValuesByFieldNameFromChoices(outputMap, choices, (queryConf === null || queryConf === void 0 ? void 0 : queryConf.values) || [], fieldNames);
    return outputMap;
};
var fillQueryValuesByFieldNameFromChoices = function (outputMap, choices, selectedValues, parentFieldNames) {
    choices.forEach(function (choice) {
        var _a;
        var choiceFieldNames = choice.fieldNames, choiceLabel = choice.label, choiceValue = choice.value;
        var fieldNames = choiceFieldNames || parentFieldNames;
        var selectedValue = (_a = selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.find(function (selectedValue) { return selectedValue.label === choiceLabel; })) === null || _a === void 0 ? void 0 : _a.value;
        fillQueryValuesByFieldNameFromChoiceValue(outputMap, choiceLabel, choiceValue, selectedValue, fieldNames);
    });
};
var fillQueryValuesByFieldNameFromChoiceValue = function (outputMap, valueLabel, choiceValue, selectedValue, parentFieldNames) {
    if (isFilterChoiceQueryValue(choiceValue)) {
        if (selectedValue) {
            addQueryValueForFieldNames(outputMap, valueLabel, parentFieldNames);
        }
    }
    else {
        var subChoices = choiceValue;
        var subSelectedValues = selectedValue && !isFilterChoiceQueryValue(selectedValue) ? selectedValue : [];
        fillQueryValuesByFieldNameFromChoices(outputMap, subChoices, subSelectedValues, parentFieldNames);
    }
};
var addQueryValueForFieldNames = function (map, value, fieldNames) {
    fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.forEach(function (fieldName) { return addQueryValueForFieldName(map, value, fieldName); });
};
var addQueryValueForFieldName = function (map, value, fieldName) {
    if (!map[fieldName]) {
        map[fieldName] = [];
    }
    map[fieldName].push(value);
};
export var buildSelectedChoicesFromSelectListFilter = function (filter, selectValue) {
    var fieldNames = filter.fieldNames, choices = filter.choices;
    return buildSelectedChoicesFromSelectListFilterChoices(choices, selectValue, fieldNames);
};
var buildSelectedChoicesFromSelectListFilterChoices = function (choices, selectValue, fieldNames) {
    return choices
        .map(function (choice) { return buildSelectedChoicesFromSelectListFilterChoice(choice, selectValue, fieldNames); })
        .filter(function (choice) { return !!choice; });
};
var buildSelectedChoicesFromSelectListFilterChoice = function (choice, selectValue, parentFieldNames) {
    var fieldNames = choice.fieldNames, value = choice.value;
    var currentFieldNames = fieldNames || parentFieldNames;
    if (isSelectListFilterChoiceDeselected(choice, selectValue, currentFieldNames)) {
        return null;
    }
    if (isFilterChoiceQueryValue(value)) {
        return choice;
    }
    var subChoices = buildSelectedChoicesFromSelectListFilterChoices(value, selectValue, currentFieldNames);
    if (subChoices.length === 0) {
        return null;
    }
    return __assign(__assign({}, choice), { value: subChoices });
};
var isSelectListFilterChoiceDeselected = function (choice, selectValue, fieldNames) {
    if (Array.isArray(choice.value)) { // array of sub-choices => cannot be selected
        return false; // because it cannot be de-selected (should NOT be filtered out)
    }
    return !isOptionSelected(selectValue, choice.label, fieldNames);
};
